export default __webpack_public_path__ + "static/media/favicon.c539e92c.ico";